import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { compose } from "redux";
import { getNotifications } from "../../../redux/actions/notificationActions";
import { connect } from "react-redux";
import TablePagination from "@material-ui/core/TablePagination";
import Notification from "./Notification";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  demo: {
    backgroundColor: theme.palette.background.paper
  },
  title: {
    margin: `${theme.spacing.unit * 4}px 0 ${theme.spacing.unit * 2}px`
  }
});

function generate(element) {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(value =>
    React.cloneElement(element, {
      key: value
    })
  );
}

function listItem() {
  return (
    <div>
      <ListItem>
        <ListItemText
          primary="Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet"
          secondary="Ayer"
        />
      </ListItem>
      <Divider />
    </div>
  );
}

class AccountNotifications extends React.Component {
  state = {
    dense: false,
    secondary: false,
    current: 1
  };

  componentDidMount() {
    let { getNotifications } = this.props;
    getNotifications();
  }

  onChangePage(event, page) {
    this.setState({ current: page + 1 });
    this.props.getNotifications({ page: page + 1 });
  }

  render() {
    const { classes, notification } = this.props;
    const { secondary, current } = this.state;
    let currentPage = notification[current];

    return (
      <React.Fragment>
        {currentPage && (
          <div className={classes.root}>
            <Grid container spacing={8}>
              <Grid item xs={12} md={6}>
                {Array.isArray(currentPage.results) &&
                  currentPage.results.map(notification => (
                    <Notification
                      key={notification.id}
                      notification={notification}
                    />
                  ))}
                <TablePagination
                  rowsPerPageOptions={[10]}
                  component="div"
                  count={currentPage.count}
                  rowsPerPage={10}
                  page={current - 1}
                  backIconButtonProps={{
                    "aria-label": "Previous Page"
                  }}
                  nextIconButtonProps={{
                    "aria-label": "Next Page"
                  }}
                  onChangePage={(event, page) => this.onChangePage(event, page)}
                />
              </Grid>
            </Grid>
          </div>
        )}
      </React.Fragment>
    );
  }
}

AccountNotifications.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  notification: state.notification
});

const enhance = compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { getNotifications }
  )
);

export default enhance(AccountNotifications);



// WEBPACK FOOTER //
// ./src/modules/account/components/AccountNotifications.js